import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=f17a10f0&scoped=true"
import script from "./Birthday.vue?vue&type=script&lang=js"
export * from "./Birthday.vue?vue&type=script&lang=js"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=f17a10f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17a10f0",
  null
  
)

export default component.exports